export const checkImageExists = (url: string | null | undefined): Promise<boolean> => {
  return new Promise((resolve) => {
    if (!url || url.trim() === "") {
      resolve(false);
      return;
    }

    const img = new Image();
    let resolved = false;

    const cleanup = () => {
      img.onload = null;
      img.onerror = null;
    };

    img.onload = () => {
      if (!resolved) {
        resolved = true;
        cleanup();
        resolve(true);
      }
    };

    img.onerror = () => {
      if (!resolved) {
        resolved = true;
        cleanup();
        resolve(false);
      }
    };

    img.src = url;

    setTimeout(() => {
      if (!resolved) {
        resolved = true;
        cleanup();
        resolve(false);
      }
    }, 5000);
  });
};
